import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const orderItemListSlice = createApi({
    reducerPath: "orderItemList",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        orderItemList: builder.query({
            query: (data) => ({ url: "/order-management/api/v1/orderitem/list", params: data, method: "GET" }),
        }),
    }),
});

export const { useOrderItemListQuery } = orderItemListSlice;
